export enum UserRole {
  ADMIN, USER
}
